import { render, staticRenderFns } from "./AdministrationPageDesktop.vue?vue&type=template&id=947f9016&scoped=true&"
import script from "./AdministrationPageDesktop.vue?vue&type=script&lang=js&"
export * from "./AdministrationPageDesktop.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationPageDesktop.vue?vue&type=style&index=0&id=947f9016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947f9016",
  null
  
)

export default component.exports